/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import { ConstantValues } from 'src/app/models/util/constantValues';
import { ITicketTO } from 'src/app/models/ticket/transportObjects/ticketTO.interface';
import { Input, Output, EventEmitter, OnDestroy, Directive, AfterViewInit } from '@angular/core';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { DeployParams } from 'src/app/deployParams';
import { UtilityService } from 'src/app/services/util/utility.service';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { TicketService } from 'src/app/services/ticket.service';
import { UserService } from 'src/app/services/user.service';
import { EventMappingType, ErrorLevel, ErrorType, FreeBetProcessingType, OfficeNumberRounding, EventTypeBonusSetting, BetslipTypeFreeBetSetting, SportTreeCondition, MinimumEventOddMode, RequestSource, TicketStatus, OddsValidationMode, TypeOfPlaceBetTicket, SuperbetMessageType } from 'src/app/models/enums';
import { ITicketItem } from 'src/app/models/ticket/ticketItem.inerface';
import { NotificationService } from 'src/app/services/notification.service';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import { ITicket } from 'src/app/models/ticket/ticket.interface';
import { IBonusSettings } from 'src/app/models/settings/bonusSettings.interface';
import { IFreeBetSetting } from 'src/app/models/settings/freeBetSetting.interface';
import { BonusService } from 'src/app/services/bonus.service';
import { FreeBetService } from 'src/app/services/freeBet.service';
import { ITicketOrderingItem } from 'src/app/models/ticket/ticketOrderingItem';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { TicketProviderService } from 'src/app/services/providers/ticket.provider.service';
import { ITicketValidationRequestTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationRequestTO.interface';
import { ITicketValidationResultTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationResultTO.interface';
import { Subscription } from 'rxjs';
import { ITicketValidationResult } from 'src/app/models/ticket-validation/ticketValidationResult.interface';
import { StorageService } from 'src/app/services/util/storage.service';
import { ITicketData } from 'src/app/models/ticket/ticketData.interface';
import { SettingsService } from 'src/app/services/settings.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
declare let jQuery: any;
@Directive()
// tslint:disable-next-line:directive-class-suffix
export abstract class TicketBase implements OnDestroy, AfterViewInit {

  protected static payin: number;
  private payinTemp: number;
  protected _ticketChanged: boolean;

  protected CV: ConstantValues = ConstantValues;

  protected language: string;
  public freeBetBalance: number;
  public accountBalance: number;
  public showSystemOptions = false;

  public superBetMsg: string;

  public superBetMessageType: SuperbetMessageType = SuperbetMessageType.NONE;

  showConfirmDialog = false;
  ticket: ITicket;
  stakeStep = 10;

  public currency: string = ConstantValues.CURRENCY;
  public isUserLoggedIn: boolean;
  public placeBetType: TypeOfPlaceBetTicket = TypeOfPlaceBetTicket.Standard;
  public superbetMessageTypeEnum = SuperbetMessageType;
  protected payinInputField: HTMLInputElement;
  public showPotentialFreeBetWinning = ViewConfigurations.showPotentialFreeBetWinnings;
  public viewConfigurations = ViewConfigurations;
  // @Input()
  // ticketItems: ITicketItem[] = [];

  // private _totalWinings: number;
  // totalWinings: number;
  // minWinings: number;
  // totalOdd: number;
  // minOdd: number;
  // numberOfBets: number;
  // possibleWin: number;
  // freeBetValue = 0;
  // freeBetValueToShow = 0;

  isMobileView: boolean;

  // @Output()
  // totalWinningsEmitter: EventEmitter<number> = new EventEmitter<number>();
  // Holds map of event and its outcomes in the ticket.
  @Input()
  ticketItemGroups: { [eventId: number]: ITicketItemGroup };

  @Input()
  orderingForTicketItemGroups: ITicketOrderingItem[] = [];

  // @Input()
  // ticketItems: ITicketItem[] = [];
  // @Input()
  // events: IEventGroup[] = [];

  @Input()
  isOddChanged: boolean;

  @Input()
  set bankersChanged(a: boolean) {
    if (a) {
      this.showSystemOptions = true;
    }
  }
  // Holds odds for each event. In case of multiple outcomes for single event
  // the value is the max odds for all outcome combinations.
  @Input()
  oddsMap: { [eventId: number]: number } = {};

  // Holds odds for each event. In case of multiple outcomes for single event
  // the value is the MIN odds for all outcome combinations.
  @Input()
  minOddsMap: { [eventId: number]: number } = {};

  @Input()
  set isTicketOnline(isTicketOnline: boolean) {
    this.ticketData.isTicketOnline = isTicketOnline;
    this.ticketService.updateTicketData(this.ticketData);
  }

  @Input()
  oddsValidationMode: OddsValidationMode;

  @Input()
  set setSuperBetMessageType(messageType: SuperbetMessageType) {
    this.superBetMessageType = messageType;
    if (this.superBetMessageType === SuperbetMessageType.MIN_NON_SB_ODD) {
      this.superBetMsg = DynamicTranslations.ticketValidation_NonSuperBetItemsOddLowerThanMinimumAllowed + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD + ' .';
    } else if (this.superBetMessageType === SuperbetMessageType.MIN_NON_SB_COUNT) {
      this.superBetMsg = DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowed + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowedPart2 + '.';
    } else if (this.superBetMessageType === SuperbetMessageType.MIN_NON_SB_ODD_AND_COUNT) {
      this.superBetMsg = DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart1 + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart2 + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD;
    }
  }

  @Output() mobileTotalOdd: EventEmitter<any> = new EventEmitter<any>();

  ticketData = { bonus: 0, bonusPercent: 0, freeBetValue: 0, freeBetValueToShow: 0 } as ITicketData;

  @Input()
  set ticketChanged(changed: boolean) {

    this.onTicketChanged(changed);
  }

  public predefinedDenominations: number[] = [];
  public taxBeforeStakeDefinitionPercent;


  // tslint:disable-next-line: adjacent-overload-signatures
  get ticketChanged() {
    return this._ticketChanged;
  }

  get displayFormat(): string {
    return ConstantValues.DISPLAY_NUMBER_FORMAT_STRING_FOR_PIPE;
  }

  get wagerPerBet(): number {
    if (this.ticketData.numberOfBets > 0) {
      this.ticketData.wagerPerBet = this.ticketData.totalStake / this.ticketData.numberOfBets;
    }
    return this.ticketData.wagerPerBet;
  }

  get wagerPerBetString(): string {
    const wagerPerBetStr = (this.ticketData.payin / this.ticketData.numberOfBets).toString();
    if (wagerPerBetStr.indexOf('.') > -1) {
      return wagerPerBetStr.slice(0, wagerPerBetStr.indexOf('.') + 3);
    }
    return wagerPerBetStr;
  }

  set payin(val: any) {
    let value = +this.stakeInputToNumber(val);
    TicketBase.payin = +value;
    if (value > ConstantValues.MAX_STAKE) {
      TicketBase.payin = ConstantValues.MAX_STAKE;
      value = ConstantValues.MAX_STAKE;
    }
    this.ticketData.payin = TicketBase.payin;

    const totalStakeCalcRes = this.ticketService.calclateTotalStake(TicketBase.payin);
    this.ticketData.totalStake = totalStakeCalcRes.totalStake;
    this.ticketData.taxBeforeStake = totalStakeCalcRes.taxBeforeStake;

    this.ticketService.initialTicketPayin = TicketBase.payin;
    if (value > 0) {
      this.ticketData.wagerPerBet = this.ticketData.totalStake / this.ticketData.numberOfBets;
    }
    this.calculateOddAndWinings();
    this.ticketService.updateTicketData(this.ticketData);
  }

  get payin() {
    return TicketBase.payin;
  }

  private subscription: Subscription = new Subscription();

  constructor(
    protected ticketService: TicketService,
    protected userService: UserService,
    private notificationService: NotificationService,
    protected bonusService: BonusService,
    protected utilityService: UtilityService,
    public freeBetService: FreeBetService,
    protected modelMapper: ModelMapperService,
    protected storage: StorageService,
    protected settingsService: SettingsService,
    protected authentificationService: AuthenticationService) {

    this.subscription.add(ticketService.placeBetClicked$.subscribe(() => this.openConfirmDialog()));
    this.subscription.add(settingsService.constantValuesLoaded$.subscribe(() => {
      this.setInitialStake();
      for (let i = 0; i < 4; i++) {
        this.predefinedDenominations[i] = ConstantValues.PREDEFINED_DENOMINATIONS[i];
      }
      if (ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition && ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent) {
        this.taxBeforeStakeDefinitionPercent = ConstantValues.TAX_DEFINITIONS.taxBeforeStakeDefinition.stakePercent;
      }
    }));
    this.subscription.add(this.userService.freebetChanged$.subscribe(() => {
      this.freeBetBalance = storage.freeBetBalance;
      this.calculateFreeBet();
    }));
    this.subscription.add(this.userService.accountBalanceChanged$.subscribe(() => this.accountBalance = storage.accountBalance));
    this.subscription.add(this.authentificationService.loggedAffiliateChangedSource$.subscribe(() => {
      if (this.authentificationService.loggedAffiliate && storage.affiliateJwtToken) {
        this.isUserLoggedIn = true;
      } else {
        this.isUserLoggedIn = true;
      }
      if (this.isUserLoggedIn) {
        this.placeBetType = TypeOfPlaceBetTicket.Standard;
      } else {
        this.placeBetType = TypeOfPlaceBetTicket.Express;
      }
      this.accountBalance = storage.accountBalance;
    }));

    this.subscription.add(this.userService.userLoggedInOut$.subscribe((x) => {
      this.isUserLoggedIn = x;
      if (this.isUserLoggedIn) {
        this.placeBetType = TypeOfPlaceBetTicket.Standard;
      } else {
        this.placeBetType = TypeOfPlaceBetTicket.Express;
      }
    }));
    this.language = storage.language;
    this.freeBetBalance = storage.freeBetBalance;
    this.accountBalance = storage.accountBalance;


    TicketBase.payin = ticketService.initialTicketPayin;
    this.ticketData.payin = TicketBase.payin;
    const totalStakeCalcRes = ticketService.calclateTotalStake(TicketBase.payin);
    this.ticketData.totalStake = totalStakeCalcRes.totalStake;
    this.ticketData.taxBeforeStake = totalStakeCalcRes.taxBeforeStake;

    this.isMobileView = utilityService.mobileView;
    // this.ticketService.ticketTotalStake = TicketBase.totalStake;
    // }

    if (this.userService.user.userSBToken || (this.authentificationService.loggedAffiliate && storage.affiliateJwtToken)) {
      this.isUserLoggedIn = true;
    }

    this.subscription.add(ticketService.fastTicketOrStorageLoaded$.subscribe(data => { if (data.totalStake) { this.payin = data.totalStake; } }));
  }

  protected stakeInputToNumber(value: string): string {
    if (!value) {
      return '0';
    }
    value = value.toString();
    let editedVal = value.replace(',', '.');
    // console.log('eVal ,to . : ' + editedVal);
    // console.log('eVal numberonly: ' + editedVal);
    editedVal = editedVal.replace('..', '.');
    // console.log('eVal .. to .: ' + editedVal);
    const lastInd = editedVal.lastIndexOf('.');
    const firstInd = editedVal.indexOf('.');
    if (firstInd === 0) {
      editedVal = editedVal.slice(0, firstInd);
    }
    if (firstInd !== lastInd) {
      if (lastInd > -1) {
        editedVal = editedVal.slice(0, lastInd);
      }
    }
    if (+editedVal >= ConstantValues.MAX_STAKE) {
      if (lastInd > -1) {
        editedVal = editedVal.slice(0, lastInd);
      }
    }
    value = editedVal;
    if (!this.payinInputField) {
      this.payinInputField = document.getElementById('totalStakeInput') as HTMLInputElement;
    }
    if (this.payinInputField) {
      this.payinInputField.value = value;
    }
    // console.log('eVal .. to .: ' + editedVal);
    return value;
  }

  ngAfterViewInit(): void {
    this.payinInputField = document.getElementById('totalStakeInput') as HTMLInputElement;
    this.payinInputField.addEventListener('input', (e) => {
      const target = e.currentTarget as HTMLInputElement;
      if (+target.value > ConstantValues.MAX_STAKE) {
        target.value = ConstantValues.MAX_STAKE.toString();
      }
    });
  }

  setInitialStake() {
    setTimeout(() => {
      this.payin = ConstantValues.INITIAL_TOTAL_STAKE;
    });
  }

  openConfirmDialog() {
    if (Object.entries(this.ticketItemGroups).map(([k, v]) => v).filter(e => e.mappingType === EventMappingType.SuperBetEvent).length > 0) {
      const nonSBEvents = Object.entries(this.ticketItemGroups).map(([k, v]) => v).filter(e => e.mappingType !== EventMappingType.SuperBetEvent);
      if (!(nonSBEvents.filter(e => Object.entries(e.ticketItems).map(([k, v]) => v).filter(v => v.odd >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD).length > 0).length >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS)) {
        this.sendNotification({
          message: DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart1 + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart2 + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD,
          title: DynamicTranslations.ticket_Error_title_errorInTicket,
          errorLevel: ErrorLevel.Notification
        } as ICustomNotification);
        return;
      }
      // if (nonSBEvents.filter(e => Object.entries(e.ticketItems).map(([k, v]) => v).filter(v => v.odd < ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD).length > 0).length > 0) {
      //   this.sendNotification({
      //     message: DynamicTranslations.ticketValidation_NonSuperBetItemsOddLowerThanMinimumAllowed + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD + '.',
      //     title: DynamicTranslations.ticket_Error_title_errorInTicket,
      //     errorLevel: ErrorLevel.Notification
      //   } as ICustomNotification);
      //   return;
      // } else if (nonSBEvents.length < ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS) {
      //   this.sendNotification({
      //     message: DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowed + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowedPart2 + '.',
      //     title: DynamicTranslations.ticket_Error_title_errorInTicket,
      //     errorLevel: ErrorLevel.Notification
      //   } as ICustomNotification);
      //   return;
      // }
    }

    this.ticket = this.createTicket();
    this.ticket.totalOdd = Math.round(this.ticket.totalOdd * 10000) / 10000;
    if (this.ticketService.isTicketValid(this.orderingForTicketItemGroups, this.ticketItemGroups, this.ticketData.possibleWin, this.ticketData.numberOfBets, this.payin)) {
      this.ticket.webPlatformCurrency = this.userService.user.userCurrency;
      this.ticket.webPlatformLanguage = this.userService.user.userLanguage;
      this.ticket.platformCustomerId = +this.userService.user.userName;
      this.showConfirmDialog = true;

      // later delete
      this.openTicketConfirm();
    }
  }

  placeBet() {
    if (Object.entries(this.ticketItemGroups).map(([k, v]) => v).filter(e => e.mappingType === EventMappingType.SuperBetEvent).length > 0) {
      const nonSBEvents = Object.entries(this.ticketItemGroups).map(([k, v]) => v).filter(e => e.mappingType !== EventMappingType.SuperBetEvent);
      if (!(nonSBEvents.filter(e => Object.entries(e.ticketItems).map(([k, v]) => v).filter(v => v.odd >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD).length > 0).length >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS)) {
        this.sendNotification({
          message: DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart1 + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_NonSuperBetItemsOddAndNumberLowerThanMinimumAllowedPart2 + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD,
          title: DynamicTranslations.ticket_Error_title_errorInTicket,
          errorLevel: ErrorLevel.Notification
        } as ICustomNotification);
        return;
      }
      // if (nonSBEvents.filter(e => Object.entries(e.ticketItems).map(([k, v]) => v).filter(v => v.odd < ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD).length > 0).length > 0) {
      //   this.sendNotification({
      //     message: DynamicTranslations.ticketValidation_NonSuperBetItemsOddLowerThanMinimumAllowed + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS_ODD + '.',
      //     title: DynamicTranslations.ticket_Error_title_errorInTicket,
      //     errorLevel: ErrorLevel.Notification
      //   } as ICustomNotification);
      //   return;
      // } else if (nonSBEvents.length < ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS) {
      //   this.sendNotification({
      //     message: DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowed + ' ' + ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS + ' ' + DynamicTranslations.ticketValidation_nonSuperBetItemsCountLowerThanAllowedPart2 + '.',
      //     title: DynamicTranslations.ticket_Error_title_errorInTicket,
      //     errorLevel: ErrorLevel.Notification
      //   } as ICustomNotification);
      //   return;
      // }
    }

    this.ticket = this.createTicket();
    this.ticket.totalOdd = Math.round(this.ticket.totalOdd * 10000) / 10000;
    if (this.ticketService.isTicketValid(this.orderingForTicketItemGroups, this.ticketItemGroups, this.ticketData.possibleWin, this.ticketData.numberOfBets, this.payin)) {
      this.ticket.webPlatformCurrency = this.userService.user.userCurrency;
      this.ticket.webPlatformLanguage = this.userService.user.userLanguage;
      this.ticket.platformCustomerId = +this.userService.user.userName;
      this.showConfirmDialog = true;
      // later delete
      this.ticketService.placeBet(this.oddsValidationMode, this.ticket, false, false);
    }
  }

  showMessageForTicketAfterPlacedBet(response: ITicketValidationResult) {
    let message = 'Ticket play response - TicketStatus : ';
    if (response.validatedTicket.ticketValidationState.ticketStatus) {
      message += TicketStatus[response.validatedTicket.ticketValidationState.ticketStatus].toString();
    } else {
      message += 'error';
    }

    const error: ICustomNotification = {
      message,
      title: 'Ticket play response',
      offlineBets: [],
      restictedItems: [],
      errorLevel: ErrorLevel.Notification,
      errorType: ErrorType.Warning,
      ticket: null,
      link: null
    };

    this.sendNotification(error);
  }

  closeConfirmDialog() {
    this.showConfirmDialog = false;
    // if odd map is changed when ticket is returned from authorization
    // this.resetAuthorizationUpdates();
  }

  // do it later
  resetAuthorizationUpdates() {
  }


  protected sendNotification(notification: ICustomNotification) {
    this.notificationService.forwardDataToNotification(notification);
  }

  protected openTicketConfirm() { }

  checkForPaste(event: any) {
    if (event.ctrlKey === true && (event.which === '118' || event.which === '86')) {
      this.preventPaste(event);
    }
  }

  preventPaste(event: any) {
    event.preventDefault();
    return false;
  }


  findClosestInArray(num: number, arr: number[]) {
    let curr = arr[0];
    arr.forEach(val => {
      if (Math.abs(num - val) < Math.abs(num - curr)) {
        curr = val;
      }
    });

    return curr;
  }

  increaseTotalStake() {
    if (ConstantValues.PREDEFINED_DENOMINATIONS.length < 1) {
      if (this.payin + ConstantValues.MIN_STAKE > ConstantValues.MAX_STAKE) {
        this.payin = ConstantValues.MAX_STAKE;
      } else {
        this.payin += ConstantValues.MIN_STAKE;
      }
      return;
    }
    const indexInArray = ConstantValues.PREDEFINED_DENOMINATIONS.indexOf(this.findClosestInArray(this.payin, ConstantValues.PREDEFINED_DENOMINATIONS));
    if (indexInArray !== -1 && indexInArray < ConstantValues.PREDEFINED_DENOMINATIONS.length - 1) {
      if (this.payin < ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray]) {
        this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray];
      } else {
        this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray + 1];
      }
    }
    if (indexInArray !== -1 && indexInArray === ConstantValues.PREDEFINED_DENOMINATIONS.length - 1) {
      if (this.payin + ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray] > ConstantValues.MAX_STAKE) {
        this.payin = ConstantValues.MAX_STAKE;
      } else {
        if (this.payin < ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray]) {
          this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray];
        } else {
          this.payin += ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray];
        }
      }
    }
  }

  decreaseTotalStake() {
    if (ConstantValues.PREDEFINED_DENOMINATIONS.length < 1) {
      if (this.payin - ConstantValues.MIN_STAKE < ConstantValues.MIN_STAKE) {
        this.payin = ConstantValues.MIN_STAKE;
      } else {
        this.payin -= ConstantValues.MIN_STAKE;
      }
      return;
    }
    if (this.payin > ConstantValues.MIN_STAKE) {
      const indexInArray = ConstantValues.PREDEFINED_DENOMINATIONS.indexOf(this.findClosestInArray(this.payin, ConstantValues.PREDEFINED_DENOMINATIONS));
      if (this.payin > ConstantValues.PREDEFINED_DENOMINATIONS[ConstantValues.PREDEFINED_DENOMINATIONS.length - 1]) {
        if (ConstantValues.PREDEFINED_DENOMINATIONS[ConstantValues.PREDEFINED_DENOMINATIONS.length - 1] < this.payin - ConstantValues.PREDEFINED_DENOMINATIONS[ConstantValues.PREDEFINED_DENOMINATIONS.length - 1]) {
          const payinToRound = this.payin - ConstantValues.PREDEFINED_DENOMINATIONS[ConstantValues.PREDEFINED_DENOMINATIONS.length - 1];
          this.payin = parseFloat(payinToRound.toFixed(10));
        } else {
          this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[ConstantValues.PREDEFINED_DENOMINATIONS.length - 1];
        }
      } else {
        if (indexInArray !== -1 && indexInArray >= 1) {
          if (ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray - 1] < ConstantValues.MIN_STAKE) {
            this.payin = ConstantValues.MIN_STAKE;
          } else {
            if (this.payin > ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray]) {
              this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray];
            } else {
              this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray - 1];
            }
          }
        } else {
          if (ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray] < ConstantValues.MIN_STAKE) {
            this.payin = ConstantValues.MIN_STAKE;
          } else {
            this.payin = ConstantValues.PREDEFINED_DENOMINATIONS[indexInArray];
          }
        }
      }
    } else {
      TicketBase.payin = ConstantValues.MIN_STAKE;
    }
  }

  focusStakeInput() {
    const stakeInput = jQuery('#totalStakeInput');
    if (this.isMobileView) {
      if (this.payin === ConstantValues.INITIAL_TOTAL_STAKE) {
        // const stakeInput = document.getElementById('totalStakeInput');
        this.payinTemp = this.payin;
        this.payin = null;
        //  console.log('test');

      }
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      setTimeout(() => {
        stakeInput[0].setSelectionRange(0, 50);
      });

    } else {
      stakeInput.select();
      stakeInput[0].select();
    }
  }

  outOfFocusStakeInput() {
    if (this.isMobileView) {
      if (this.payin !== this.payinTemp && this.payin === 0) {
        this.payin = this.payinTemp;
      }
    }
  }

  protected abstract onTicketChanged(changed: boolean);

  protected abstract calculateOddAndWinings();

  protected abstract createTicket();

  protected abstract calculateFreeBet();

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
